/**
 * SyncAdapter interface.
 * Phase 1 uses BroadcastChannelAdapter (same-device).
 * Future phases will drop in WebSocketAdapter without changing game logic.
 *
 * Every adapter must expose:
 *   - publish(event): void       // send an event to all peers
 *   - subscribe(handler): fn     // register a handler; returns unsubscribe fn
 *   - close(): void
 */

export class SyncAdapter {
  publish(event) {
    throw new Error("SyncAdapter.publish not implemented");
  }
  subscribe(handler) {
    throw new Error("SyncAdapter.subscribe not implemented");
  }
  close() {}
}
